import styled from 'styled-components';

const Wrapper = styled.div`
  display: block;
  width: 100%;
  // background: ${(props) => props.theme.colors.outline};
  border-radius: 12px;
  overflow: hidden;
  font-family: ManropeLight, sans-serif;
  margin-bottom: 16px;
  border: 1px solid ${(props) => props.theme.colors.outline};

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-size: 16px;
    margin-bottom: 16px;
    cursor: default;
  }

  .notes-card-container {
    cursor: default;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    font-size: 13px;
    line-height: 18px;
  }

  .notes-card-footer {
    font-size: 13px;
    margin-top: 15px;
    width: 100%;
    color: ${(props) => props.theme.colors.inactive};
  }

  input {
    width: 100% !important;
  }
`;

const ErrorMessage = styled.p`
  color: ${(props) => props.theme.colors.red};
  text-align: center;
  font-family: ManropeLight, sans-serif;
`;

export default { Wrapper, ErrorMessage };
